export const SET_IPS = "setIPs";
export const CLEAR_IPS = "clearIPs";
export const SET_IP = "setIP";
export const CLEAR_IP = "clearIP";
export const SET_REMOVED_IPS = "setRemovedIps";
export const CLEAR_REMOVED_IPS = "clearRemovedIps";
export const ADD_IP = "addIP";
export const REMOVE_IP = "removeIP";
